<template>
	<div :class="[
    'valueTd',
    'eldCount',
    item.align,
    { active: !!line[item.value] }
  ]"
	>
		<button :disabled="!line[item.value]" @click="onClick('count')">
			{{ line[item.value] }}
		</button>
	</div>
</template>

<script>
export default {
	name: "Count",
	props: {
		item: Object,
		line: Object,
	},
	methods: {
		onClick(flag) {
			this.$emit('updateModEvent', { flag, line: this.line, item: this.item });
		},
	},
};
</script>

<style scoped lang="scss">
.eldCount {
	button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		overflow: hidden;
		font-size: 12px;
		margin: 0 auto;
		color: var(--base-green);
		background: rgba(255, 255, 255, 0.3);
	}
	&.active {
		button {
			color: #fff;
			background: var(--base-green);
		}
	}
}
</style>
